import api from '../api.js'
import store from '../../store'

export default({
    login(obj){        
        return api.post(`/v2/auth/login`, obj);
    },
    logout(){        
        return api.post(`/v2/auth/logout?token=${store.getters.access_token}`);
    },
    recovery_password(obj){        
        return api.post(`/v2/auth/recovery-password`, obj);
    },
    validate_recovery_password(token){        
        return api.get(`/v2/auth/reset-password/${token}`);
    },
    me(){
        return api.get(`/v2/auth/me?token=${store.getters.access_token}`);
    },
    reset_password(obj){
        return api.post(`/v2/auth/new-password?token=${obj.token}`, obj);
    },
    email_verification(email){
        return api.get(`/v2/auth/email-verification/${email}`);
    },
        // 2FA – step 2 del login: verifica il codice OTP
    verify2fa(obj){
        return api.post(`/v2/auth/verify-2fa`, obj);
    },
    // 2FA – genera secret e QR code (dalla pagina profilo)
    setup2fa(){
        return api.get(`/v2/auth/2fa/setup?token=${store.getters.access_token}`);
    },
    // 2FA – conferma il setup inviando il primo codice OTP
    confirm2fa(obj){
        return api.post(`/v2/auth/2fa/confirm?token=${store.getters.access_token}`, obj);
    },
    // 2FA – disabilita il 2FA (richiede password di conferma)
    disable2fa(obj){
        return api.post(`/v2/auth/2fa/disable?token=${store.getters.access_token}`, obj);
    },
});